<template>
  <section class="webphone-view">
    <WebPhoneAside />
    <!-- webphone-view__content (class) is used in contactsSidebar.vue to render add form in  -->
    <div class="webphone-view__content">
      <router-view />
    </div>
  </section>
</template>

<script>
  import { useBrandStore } from '@bv/stores';
  import { useToast } from '@bv/composables/common/toast';
  import WebPhoneAside from '@/components/WebPhone/WebPhoneSidebar/WebPhoneSidebar.vue';
  import { mapState } from 'pinia';
  import { userDetailsStore } from '@/stores/auth/user-details.store';

  const toast = useToast();

  export default {
    name: 'WebPhoneView',
    components: {
      WebPhoneAside,
    },
    computed: {
      ...mapState(userDetailsStore, ['currentExtension']),
      ...mapState(useBrandStore, ['config']),
    },
    mounted() {
      if (!this.currentExtension.number) {
        toast.error(this.$t('call_center.call_permission_error'));
      }
    },
  };
</script>

<style lang="scss">
  main:has(> .webphone-view) {
    height: max(100%, 500px);
    overflow-y: hidden;
  }
</style>

<style lang="scss" scoped>
  .webphone-view {
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    display: grid;
    grid-template-columns: auto 1fr;
    padding: 0;

    &__content {
      display: flex;
      gap: 24px;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      position: relative;
    }
  }
</style>
